/**
 * Vuex 状态管理
 */
import Vue from 'vue'
import Vuex from 'vuex'
import { authAPI, surveyAPI } from '../api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('petboss_token') || '',
    user: JSON.parse(localStorage.getItem('petboss_user') || 'null'),
    sidebarCollapsed: false,
    shops: [],
    currentShopId: parseInt(localStorage.getItem('petboss_current_shop_id')) || null
  },

  getters: {
    isLoggedIn: state => !!state.token,
    userName: state => state.user ? state.user.name : '',
    userRole: state => state.user ? state.user.role : '',
    shopName: state => {
      if (state.currentShopId && state.shops.length > 0) {
        const shop = state.shops.find(s => s.id === state.currentShopId)
        return shop ? shop.name : ''
      }
      return state.user ? state.user.shop : ''
    },
    permissions: state => state.user ? state.user.permissions : [],
    shopList: state => state.shops,
    currentShop: state => {
      if (state.currentShopId) {
        return state.shops.find(s => s.id === state.currentShopId)
      }
      return state.shops[0] || null
    }
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      if (token) {
        localStorage.setItem('petboss_token', token)
      } else {
        localStorage.removeItem('petboss_token')
      }
    },

    SET_USER(state, user) {
      state.user = user
      if (user) {
        localStorage.setItem('petboss_user', JSON.stringify(user))
      } else {
        localStorage.removeItem('petboss_user')
      }
    },

    TOGGLE_SIDEBAR(state) {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },

    SET_SHOPS(state, shops) {
      state.shops = shops
    },

    SET_CURRENT_SHOP(state, shopId) {
      state.currentShopId = shopId ? parseInt(shopId) : null
      if (shopId) {
        localStorage.setItem('petboss_current_shop_id', shopId)
      } else {
        localStorage.removeItem('petboss_current_shop_id')
      }
    }
  },

  actions: {
    // 登录
    async login({ commit }, { username, password }) {
      try {
        const data = await authAPI.login({ username, password })
        commit('SET_TOKEN', data.token)
        commit('SET_USER', data.user)
        return data
      } catch (error) {
        throw error
      }
    },

    // 获取当前用户信息
    async getMe({ commit }) {
      try {
        const user = await authAPI.getMe()
        commit('SET_USER', user)
        return user
      } catch (error) {
        throw error
      }
    },

    // 登出
    async logout({ commit }) {
      localStorage.removeItem('petboss_token')
      localStorage.removeItem('petboss_user')
      commit('SET_TOKEN', '')
      commit('SET_USER', null)
    },

    // 获取店铺列表
    async fetchShops({ commit, state }) {
      try {
        const data = await surveyAPI.getShops()
        commit('SET_SHOPS', data.shops || [])
        // 如果没有当前店铺，默认选第一个
        if (!state.currentShopId && data.shops && data.shops.length > 0) {
          commit('SET_CURRENT_SHOP', data.shops[0].id)
        }
        return data.shops
      } catch (error) {
        throw error
      }
    },

    // 切换店铺
    async switchShop({ commit }, shopId) {
      commit('SET_CURRENT_SHOP', shopId)
      // 触发页面刷新事件
      window.dispatchEvent(new CustomEvent('shop-changed', { detail: { shopId } }))
    }
  }
})
